// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: #fff;
    color: #1a202c;
}

.main-content {
    flex: 1 1;
    padding: 2rem 0;
}

.main-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
}

.content-section {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.filter-container-home {
    border: 1px solid #e2e8f0;
    border-radius: 0.5rem;
    background-color: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.filter-content {
    padding: 1.5rem;
}

.filter-grid {
    display: grid;
    grid-gap: 1.5rem;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
}

.filter-item {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 100%;
}

.filter-label {
    font-size: .875rem;
    font-weight: 500;
    color: #4a5568;
}

.input-wrapper {
    position: relative;
}

.search-icon {
    position: absolute;
    left: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    width: 1rem;
    height: 1rem;
    color: #a0aec0;
}

.search-input {
    all: initial;
    display: flex;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    background-color: white !important;
    padding: 0.5rem 0.75rem 0.5rem 2.5rem;
    font-size: 0.875rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.375rem;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.select-button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.375rem;
    background-color: #fff;
    cursor: pointer;
}

.select-text {
    color: #a0aec0;
}

.select-icon {
    width: 1rem;
    height: 1rem;
    color: #a0aec0;
}

.dropdown-menu {
    position: absolute;
    margin-top: 0.25rem;
    width: 100%;
    border: 1px solid #e2e8f0;
    border-radius: 0.375rem;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 10;
}

.dropdown-item {
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;
}

.dropdown-item:hover {
    background-color: #ebf8ff;
}

.table-container-home {
    border: 1px solid #e2e8f0;
    border-radius: 0.5rem;
    background-color: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    overflow: hidden;
}

.table-scroll {
    overflow-x: auto;
}

.professors-table-home {
    width: 100%;
    border-collapse: collapse;
}

.table-header {
    background-color: #f7fafc;
}

.table-cell {
    padding: 1rem;
    text-align: center;
    font-size: 0.875em;
    font-weight: 500;
    color: rgb(79, 71, 71);
    border-bottom: 1px solid #e2e8f0;
}

.table-cell .email-data {
    position: relative;
}

.table-cell p {
    margin: 0;
    -webkit-user-select: none;
            user-select: none;
}

.table-cell .email-data>div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    pointer-events: none;
}

.photo-cell {
    width: 80px;
}

.name-cell,
.department-cell,
.rank-cell,
.research-cell,
.profile-cell {
    min-width: 120px;
}

.header-with-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.25rem;
}

.sort-icon {
    width: 1rem;
    height: 1rem;
}

.sort-icon.active {
    color: var(--primary-color);
}

.table-header th {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.table-row:hover {
    background-color: #f7fafc;
}

.photo-wrapper {
    display: inline-block;
    cursor: pointer;
}

.professor-photo {
    border-radius: 50%;
    object-fit: cover;
}

.view-button {
    background: none;
    border: none;
    color: #3b82f6;
    font-size: 0.875rem;
    cursor: pointer;
    padding: 0.375rem 0.75rem;
    border-radius: 0.375rem;
    transition: background-color 0.2s ease-in-out;
}

.view-button:hover {
    background-color: #ebf8ff;
}

@media (max-width: 768px) {
    .main-container {
        padding: 0 0.5rem;
    }

    .filter-content {
        padding: 1rem;
    }

    .filter-grid {
        grid-template-columns: 1fr;
        gap: 1rem;
    }

    .filter-item {
        gap: 0.25rem;
    }

    .filter-label {
        font-size: 0.8rem;
    }

    .search-input,
    .select-button {
        font-size: 0.8rem;
        height: 36px;
    }

    .table-cell {
        padding: 0.75rem 0.5rem;
        font-size: 0.8rem;
    }

    .name-cell,
    .department-cell,
    .rank-cell,
    .research-cell,
    .profile-cell {
        min-width: 100px;
    }

    .view-button {
        padding: 0.25rem 0.5rem;
        font-size: 0.8rem;
    }

    .dropdown-menu {
        max-height: 200px;
        overflow-y: auto;
    }

    .dropdown-item {
        padding: 0.25rem 0.5rem;
        font-size: 0.8rem;
    }
}

@media (max-width: 480px) {
    .main-content {
        padding: 1rem 0;
    }

    .table-cell {
        padding: 0.5rem 0.25rem;
        font-size: 0.75rem;
    }

    .header-with-icon {
        flex-direction: column;
        gap: 0;
    }

    .sort-icon {
        width: 0.8rem;
        height: 0.8rem;
    }

    .view-button {
        padding: 0.2rem 0.4rem;
        font-size: 0.75rem;
    }
}

.table-scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.table-cell p {
    -webkit-user-select: none;
    user-select: none;
}

@media (max-width: 768px) {
    .table-scroll {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        display: block;
        width: 100%;
    }

    .professors-table-home {
        width: auto;
        min-width: 600px;
    }

    .table-cell {
        padding: 0.75rem 0.5rem;
        font-size: 0.8rem;
        white-space: nowrap;
    }

    .view-button {
        padding: 0.3rem 0.6rem;
        font-size: 0.75rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ProfessorList/ProfessorList.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,2DAA2D;AAC/D;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,qCAAqC;IACrC,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,uBAAuB;IACvB,sBAAsB;IACtB,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;IACtB,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;;;;;IAKI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,uBAAuB;IACvB,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,uBAAuB;QACvB,iBAAiB;IACrB;;IAEA;;;;;QAKI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,uBAAuB;QACvB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,MAAM;IACV;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IAGzB,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;QAChB,iCAAiC;QACjC,cAAc;QACd,WAAW;IACf;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;AACJ","sourcesContent":[".app-container {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    background-color: #fff;\n    color: #1a202c;\n}\n\n.main-content {\n    flex: 1;\n    padding: 2rem 0;\n}\n\n.main-container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 1rem;\n}\n\n.content-section {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n.filter-container-home {\n    border: 1px solid #e2e8f0;\n    border-radius: 0.5rem;\n    background-color: #fff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.filter-content {\n    padding: 1.5rem;\n}\n\n.filter-grid {\n    display: grid;\n    grid-gap: 1.5rem;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n}\n\n.filter-item {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    width: 100%;\n}\n\n.filter-label {\n    font-size: .875rem;\n    font-weight: 500;\n    color: #4a5568;\n}\n\n.input-wrapper {\n    position: relative;\n}\n\n.search-icon {\n    position: absolute;\n    left: 0.75rem;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 1rem;\n    height: 1rem;\n    color: #a0aec0;\n}\n\n.search-input {\n    all: initial;\n    display: flex;\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    width: 100%;\n    height: 40px;\n    background-color: white !important;\n    padding: 0.5rem 0.75rem 0.5rem 2.5rem;\n    font-size: 0.875rem;\n    border: 1px solid #e2e8f0;\n    border-radius: 0.375rem;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.select-button {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.5rem 0.75rem;\n    font-size: 0.875rem;\n    border: 1px solid #e2e8f0;\n    border-radius: 0.375rem;\n    background-color: #fff;\n    cursor: pointer;\n}\n\n.select-text {\n    color: #a0aec0;\n}\n\n.select-icon {\n    width: 1rem;\n    height: 1rem;\n    color: #a0aec0;\n}\n\n.dropdown-menu {\n    position: absolute;\n    margin-top: 0.25rem;\n    width: 100%;\n    border: 1px solid #e2e8f0;\n    border-radius: 0.375rem;\n    background-color: #fff;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    z-index: 10;\n}\n\n.dropdown-item {\n    padding: 0.375rem 0.75rem;\n    font-size: 0.875rem;\n    cursor: pointer;\n    transition: background-color 0.2s ease-in-out;\n}\n\n.dropdown-item:hover {\n    background-color: #ebf8ff;\n}\n\n.table-container-home {\n    border: 1px solid #e2e8f0;\n    border-radius: 0.5rem;\n    background-color: #fff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    overflow: hidden;\n}\n\n.table-scroll {\n    overflow-x: auto;\n}\n\n.professors-table-home {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.table-header {\n    background-color: #f7fafc;\n}\n\n.table-cell {\n    padding: 1rem;\n    text-align: center;\n    font-size: 0.875em;\n    font-weight: 500;\n    color: rgb(79, 71, 71);\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.table-cell .email-data {\n    position: relative;\n}\n\n.table-cell p {\n    margin: 0;\n    user-select: none;\n}\n\n.table-cell .email-data>div {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 10;\n    pointer-events: none;\n}\n\n.photo-cell {\n    width: 80px;\n}\n\n.name-cell,\n.department-cell,\n.rank-cell,\n.research-cell,\n.profile-cell {\n    min-width: 120px;\n}\n\n.header-with-icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 0.25rem;\n}\n\n.sort-icon {\n    width: 1rem;\n    height: 1rem;\n}\n\n.sort-icon.active {\n    color: var(--primary-color);\n}\n\n.table-header th {\n    cursor: pointer;\n    user-select: none;\n}\n\n.table-row:hover {\n    background-color: #f7fafc;\n}\n\n.photo-wrapper {\n    display: inline-block;\n    cursor: pointer;\n}\n\n.professor-photo {\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.view-button {\n    background: none;\n    border: none;\n    color: #3b82f6;\n    font-size: 0.875rem;\n    cursor: pointer;\n    padding: 0.375rem 0.75rem;\n    border-radius: 0.375rem;\n    transition: background-color 0.2s ease-in-out;\n}\n\n.view-button:hover {\n    background-color: #ebf8ff;\n}\n\n@media (max-width: 768px) {\n    .main-container {\n        padding: 0 0.5rem;\n    }\n\n    .filter-content {\n        padding: 1rem;\n    }\n\n    .filter-grid {\n        grid-template-columns: 1fr;\n        gap: 1rem;\n    }\n\n    .filter-item {\n        gap: 0.25rem;\n    }\n\n    .filter-label {\n        font-size: 0.8rem;\n    }\n\n    .search-input,\n    .select-button {\n        font-size: 0.8rem;\n        height: 36px;\n    }\n\n    .table-cell {\n        padding: 0.75rem 0.5rem;\n        font-size: 0.8rem;\n    }\n\n    .name-cell,\n    .department-cell,\n    .rank-cell,\n    .research-cell,\n    .profile-cell {\n        min-width: 100px;\n    }\n\n    .view-button {\n        padding: 0.25rem 0.5rem;\n        font-size: 0.8rem;\n    }\n\n    .dropdown-menu {\n        max-height: 200px;\n        overflow-y: auto;\n    }\n\n    .dropdown-item {\n        padding: 0.25rem 0.5rem;\n        font-size: 0.8rem;\n    }\n}\n\n@media (max-width: 480px) {\n    .main-content {\n        padding: 1rem 0;\n    }\n\n    .table-cell {\n        padding: 0.5rem 0.25rem;\n        font-size: 0.75rem;\n    }\n\n    .header-with-icon {\n        flex-direction: column;\n        gap: 0;\n    }\n\n    .sort-icon {\n        width: 0.8rem;\n        height: 0.8rem;\n    }\n\n    .view-button {\n        padding: 0.2rem 0.4rem;\n        font-size: 0.75rem;\n    }\n}\n\n.table-scroll {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n}\n\n.table-cell p {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n@media (max-width: 768px) {\n    .table-scroll {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n        display: block;\n        width: 100%;\n    }\n\n    .professors-table-home {\n        width: auto;\n        min-width: 600px;\n    }\n\n    .table-cell {\n        padding: 0.75rem 0.5rem;\n        font-size: 0.8rem;\n        white-space: nowrap;\n    }\n\n    .view-button {\n        padding: 0.3rem 0.6rem;\n        font-size: 0.75rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
